import { useEffect, useMemo } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import 'dayjs/locale/ar';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hi';
import 'dayjs/locale/it';
import 'dayjs/locale/pa-in';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ur';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/en-ca';
import { useTranslation } from 'react-i18next';

import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';

export default function useLocale(options = { skip: false }) {
  const { i18n } = useTranslation();

  const { data, error } = useGetPatientQuery(undefined, { skip: options.skip });

  const patientLocale = useMemo(() => {
    if (!data || error) return null;

    const { languageId, languages } = data;

    const language = _.find(languages, { id: languageId });
    const locale = language?.languageCode;

    if (!locale) {
      return 'en';
    }

    return locale;
  }, [data, error]);

  useEffect(() => {
    if (!patientLocale) {
      return;
    }

    switch (patientLocale) {
      case 'pa':
        dayjs.locale('pa-in');
        break;
      case 'zh-HK':
        dayjs.locale('zh-hk');
        break;
      default:
        dayjs.locale(patientLocale);
    }

    i18n.changeLanguage(patientLocale);
  }, [patientLocale]);

  return {
    patientLocale,
  };
}
